import React, { Component } from 'react';
import "../node_modules/video-react/dist/video-react.css"; // import css
import { connect } from 'react-redux'
import videojs from 'video.js';

class Video extends Component {
  constructor() {
    super()
    this.player = null;
    this.loadMedia = this.loadMedia.bind(this);
    this.stop = this.stop.bind(this);
    this.state = {
      addHasPlayed: false,
      addLoaded:false,
      castIsPlaying: false,
      vastXml: null,
      player: {
        // preferredTech: ['hls'],
        autoplay: false,
        controls: true,
        fluid: true,
        sources: [],
        html5: {
          hls: {
            withCredentials: false
          }
        }
      },

    }
  }

  componentDidMount() {
    this.player = videojs(this.videoNode, this.state.player);
    
  }

  componentWillReceiveProps(newProps) {

    if (newProps.channel) {

      this.player.bigPlayButton.show();
      this.player.pause();
      this.player.currentTime(0);


      this.player.poster(newProps.channel.logo_url);
      this.player.src({
        src: this.getCors(newProps.channel),
        type: 'application/x-mpegURL',
      })
    }
  }


  render() {
    return (
      <video
          id='player'
          ref={(video) => this.videoNode = video}
          className="video-js"
          controls
          data={this.state.video}
          preload="auto">
        </video>

    )
  }

  loadMedia(channel) {
    this.player.video.video.src = this.getCors(channel);
    this.player.video.video.type = 'application/x-mpegURL'
    this.player.video.video.withCredentials=true
  }
  getCors(channel) {
    if (channel.cors) return 'https://bgtv-cors.herokuapp.com/' + channel.url;
    return channel.url;
  }
  stop() {
    this.player.video.video.stop();
  }
}


const mapStateToProps = (state, ownProps) => {
  return {
    channel: state.video.channel,
    cast: state.cast
  }
}



export default connect(mapStateToProps)(Video);



// WEBPACK FOOTER //
// ./src/video.js